import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./slide.module.css";
import { useSelector } from "react-redux";

function Slide() {
  const products = useSelector((state) => state.products);

  const featuredProducts = products.filter(
    (product) => product.featured && product.deletedAt === null
  );

  return (
    featuredProducts.length > 3 && (
      <div className={styles.listProducts + " container"}>
        <div className="row justify-content-center">
          <div className="col-12 text-center pb-4">
            <Link
              className={styles.seeMore + " fs-6 fw-bold text-decoration-none"}
              to="/products"
            >
              <h3 className={styles.h3Slide}>Productos más vendidos</h3>
            </Link>
          </div>

          <div
            className={styles.slideCard + " col-sm-12 col-md-6 col-lg-3 p-2"}
          >
            <Link
              to={`/${featuredProducts[0].slug}`}
              className="text-decoration-none"
            >
              <img
                src={featuredProducts[0].pictures[0].img1}
                className=""
                alt=""
              />
              <div className="d-flex flex-column text-center mt-3">
                <h5 className={styles.productTitle + " fw-bold mb-0"}>
                  {featuredProducts[0].name}
                </h5>
                <small className="fs-6 text-muted">
                  $ {featuredProducts[0].price}
                </small>
              </div>
            </Link>
          </div>
          <div
            className={styles.slideCard + " col-sm-12 col-md-6 col-lg-3 p-2"}
          >
            <Link
              to={`/${featuredProducts[1].slug}`}
              className="text-decoration-none"
            >
              <img
                src={featuredProducts[1].pictures[0].img1}
                className=""
                alt=""
              />
              <div className="d-flex flex-column text-center mt-3">
                <h5 className={styles.productTitle + " fw-bold mb-0"}>
                  {featuredProducts[1].name}
                </h5>
                <small className="fs-6 text-muted">
                  $ {featuredProducts[1].price}
                </small>
              </div>
            </Link>
          </div>
          <div
            className={styles.slideCard + " col-sm-12 col-md-6 col-lg-3 p-2"}
          >
            <Link
              to={`/${featuredProducts[2].slug}`}
              className="text-decoration-none"
            >
              <img
                src={featuredProducts[2].pictures[0].img1}
                className=""
                alt=""
              />
              <div className="d-flex flex-column text-center mt-3">
                <h5 className={styles.productTitle + " fw-bold mb-0"}>
                  {featuredProducts[2].name}
                </h5>
                <small className="fs-6 text-muted">
                  $ {featuredProducts[2].price}
                </small>
              </div>
            </Link>
          </div>
          <div
            className={styles.slideCard + " col-sm-12 col-md-6 col-lg-3 p-2"}
          >
            <Link
              to={`/${featuredProducts[3].slug}`}
              className="text-decoration-none"
            >
              <img
                src={featuredProducts[3].pictures[0].img1}
                className=""
                alt=""
              />
              <div className="d-flex flex-column text-center mt-3">
                <h5 className={styles.productTitle + " fw-bold mb-0"}>
                  {featuredProducts[3].name}
                </h5>
                <small className="fs-6 text-muted">
                  $ {featuredProducts[3].price}
                </small>
              </div>
            </Link>
          </div>
        </div>
      </div>
    )
  );
}

export default Slide;
